/** An organization's automations, read from the list its pages already load (Feature 74). */
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { listOrganizationLinkages } from '@optum/api-client/endpoints/organization-linkages';

import { qk } from '../../lib/query-keys.js';
import { orgAutomations, type OrgAutomations } from './orgAutomations.js';

export function useOrgAutomations(orgId: string): OrgAutomations & { loading: boolean } {
  const linkages = useQuery({
    queryKey: qk.organizationLinkages(orgId),
    queryFn: () => listOrganizationLinkages(orgId),
  });
  const found = useMemo(() => orgAutomations(linkages.data ?? []), [linkages.data]);
  return { ...found, loading: linkages.isPending };
}
